import { Navigate } from "react-router-dom";
import { autoLogout } from "./autoLogout";

export const ProtectedRoutes = (Component) => {
  const validToken = autoLogout();
  if (!validToken) {
    // Carry the destination through login, the same way the 401 interceptor in
    // config/axios.js does, so email links into guarded pages survive signing in.
    const redirectUrl = window.location.pathname + window.location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectUrl)}`} replace />;
  }
  return <Component />;
};
